import { render, staticRenderFns } from "./orderModel.vue?vue&type=template&id=062ef1ca&scoped=true&"
import script from "./orderModel.vue?vue&type=script&lang=js&"
export * from "./orderModel.vue?vue&type=script&lang=js&"
import style0 from "./orderModel.vue?vue&type=style&index=0&id=062ef1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ef1ca",
  null
  
)

export default component.exports